var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":"tour-trigger"}},[_c('TourCard',_vm._b({staticClass:"floating-tour fixed bottom-8 left-8 w-80 z-50",class:{ 'should-animate': _vm.shouldAnimate }},'TourCard',_vm.currentStep,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }